// extracted by mini-css-extract-plugin
export default {"container":"gr-z","heading":"hr-z","text":"ir-z","info":"jr-z","link":"kr-z","fullMaxWidth":"lr-z"};